/**
 * Detection helpers for the miniapp-shell prerender pipeline.
 *
 * The shell prerenders each landing route with Playwright and serves the
 * captured HTML from a cache. Two distinct situations:
 *
 *  - isPrerenderCapture(): this page is being snapshotted by Playwright
 *    right now (cache GENERATION). The shell appends a `prerender` query
 *    flag to the capture URL. Use it to render a lightweight placeholder
 *    and skip side-effects that shouldn't run headless/offline.
 *
 *  - isPrerenderedPage(): the HTML being hydrated was produced by the
 *    prerender pipeline and served from cache. The pipeline stamps
 *    `<html data-prerendered="true">`. Absent in standalone `npm run dev`.
 */

// The pipeline navigates Playwright to `…&prerender` and then appends the
// route slug onto the end, producing `…&prerender/batch` — so the flag is
// not a clean `prerender` query key. Match the token in any of those forms.
export const isPrerenderCapture = (): boolean => typeof window !== 'undefined' && /(?:^|[?&])prerender(?:[/=&]|$)/.test(window.location.search);

export const isPrerenderedPage = (): boolean => typeof document !== 'undefined' && document.documentElement.getAttribute('data-prerendered') === 'true';
